import { Box, VStack, Heading, Text, Container, HStack, Link as CLink, LinkBox, LinkOverlay } from "@chakra-ui/react";
import { Link } from "@inertiajs/react";
import { my_settings_player_path, my_settings_player_id_path, my_settings_accounts_path, my_settings_notifications_path, logout_path } from "@/routes";

export default function Index() {
  const settingsItems = [
    {
      href: my_settings_player_path(),
      title: "プレイヤー情報",
      description: "表示名やプロフィール情報を編集",
      icon: "👤",
    },
    {
      href: my_settings_player_id_path(),
      title: "プレイヤーID 変更",
      description: "ユニークなプレイヤーIDを設定",
      icon: "🆔",
    },
    {
      href: my_settings_accounts_path(),
      title: "アカウント連携編集",
      description: "外部アカウントとの連携を管理",
      icon: "🔗",
    },
    {
      href: my_settings_notifications_path(),
      title: "通知設定",
      description: "Push通知などの設定を管理",
      icon: "🔔",
    },
  ];

  return (
    <Container maxW="4xl" py={8}>
      <Box>
        <Heading size="xl" mb={8} color="gray.800">
          設定
        </Heading>

        <VStack gap={4} align="stretch">
          {settingsItems.map((item, index) => (
            <LinkBox
              key={index}
              bg="white"
              borderColor="gray.200"
              borderWidth="1px"
              borderRadius="lg"
              p={6}
              _hover={{
                bg: "gray.50",
                transform: "translateY(-2px)",
                shadow: "md",
              }}
              transition="all 0.2s"
              cursor="pointer"
            >
              <HStack gap={4} align="center">
                <Box p={3} borderRadius="lg" bg="blue.50" fontSize="2xl">
                  {item.icon}
                </Box>

                <VStack align="start" gap={1} flex={1}>
                  <LinkOverlay as={Link} href={item.href} fontWeight="semibold" fontSize="lg" color="gray.800">
                    {item.title}
                  </LinkOverlay>
                  <Text color="gray.600" fontSize="sm">
                    {item.description}
                  </Text>
                </VStack>

                <Box color="gray.400" fontSize="lg">
                  ›
                </Box>
              </HStack>
            </LinkBox>
          ))}
        </VStack>

        <Box mt={8} textAlign="right" pr={4}>
          <CLink asChild>
            <Link href={logout_path()} method="delete">
              ログアウト
            </Link>
          </CLink>
        </Box>
      </Box>
    </Container>
  );
}
